<template>
  <labeled-form-control label="Gender">
    <div class="col">
      <div class="row">
        <div class="d-flex">
          <input v-model="genderId" :value="2" type="radio"/><span class="ml-2">Male</span>
        </div>
        <div class="ml-4 d-flex">
          <input v-model="genderId" :value="3" type="radio"/><span class="ml-2">Female</span>
        </div>
      </div>
    </div>
  </labeled-form-control>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import LabeledFormControl from '@/components/Layout/LabeledFormControl.vue'

export default {
  name: 'PetGender',
  props: {
    petId: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('ClientRegistrationUpload', [
      'findPet'
    ]),
    pet () {
      return this.findPet(this.petId)
    },
    genderId: {
      get () {
        return this.pet.genderId
      },
      set (value) {
        this.updateGenderId({ petId: this.petId, value })
      }
    }
  },
  methods: {
    ...mapMutations('ClientRegistrationUpload', [
      'updateGenderId'
    ])
  },
  components: {
    'labeled-form-control': LabeledFormControl
  }
}
</script>
